<template>
    <el-dialog
            :title="dialogTitle"
            :visible.sync="dialogVisible">

        <el-form :model="obj" ref="addEditForm" status-icon :rules="rules">
            <el-row :gutter="10">
                <el-col :span="24">
                    <el-form-item prop="title">
                        <el-input placeholder="Titel" v-model="obj.title"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="24">
                    <el-form-item prop="branchId">
                        <el-select v-model="obj.branchId"
                                   placeholder="Tak"
                                   class="w-full">
                            <span slot="prefix"><i class="el-icon-medal pl-1"></i></span>
                            <el-option
                                    v-for="item in branchOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                    :disabled="$store.getters.getBranches.indexOf(item.id) < 0">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-form-item prop="whenDate">
                        <el-date-picker
                                v-model="obj.whenDate"
                                type="date"
                                class="w-full"
                                placeholder="Datum">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item prop="whenTime">
                        <el-time-picker
                                v-model="obj.whenTime"
                                class="w-full"
                                format="HH:mm"
                                placeholder="Tijd">
                        </el-time-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-form-item prop="isPublic">
                    <el-tooltip class="item" effect="dark" content="Privé items worden enkel getoond aan ingelogde gebruikers." placement="top">
                        <el-switch
                                v-model="obj.isPrivate"
                                active-text="Privaat"
                                inactive-text="Publiek">
                        </el-switch>
                    </el-tooltip>
                </el-form-item>
            </el-row>
            <el-row :gutter="10">
                <el-col :span="24">
                    <el-form-item prop="description">
                        <text-editor ref="textEditorRef" v-model="obj.description" :current="obj.description"></text-editor>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <!-- Footer -->
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">Annuleer</el-button>
            <el-button type="primary" @click="submitForm('addEditForm')" :loading="loading">Opslaan</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import TextEditor from "../../forms/TextEditor";
    export default {
        name: "eventDialog",
        props: ['branchOptions'],
        components: {
            TextEditor
        },
        data() {
            return {
                dialogTitle: "",
                itemName: "Evenement",
                dialogVisible: false,
                adding: false,
                obj: this.getEmptyObject(),
                loading: false,

                // Rules
                rules: {
                    title: [
                        {required: true, message: 'Vul een titel in.', trigger: 'blur'}
                    ],
                    whenDate: [
                        {required: true, message: 'Selecteer een datum.', trigger: 'blur'}
                    ],
                    whenTime: [
                        {required: true, message: 'Selecteer een tijdstip.', trigger: 'blur'}
                    ],
                    branchId: [
                        {required: true, message: 'Selecteer een tak.', trigger: 'blur'}
                    ],
                    description: [
                        {required: true, message: 'Vul een beschrijving in.', trigger: 'blur'}
                    ]
                }
            }
        },
        methods: {
            edit(obj) {
                this.dialogTitle = `${this.itemName} wijzigen`
                this.dialogVisible = true
                this.adding = false
                this.obj = JSON.parse(JSON.stringify(obj));
                this.reset()
            },
            add() {
                this.dialogTitle = `${this.itemName} toevoegen`
                this.dialogVisible = true
                this.adding = true
                this.obj = this.getEmptyObject()
                this.reset()
            },
            reset() {
                if(this.$refs['addEditForm']) {
                    this.$refs['addEditForm'].resetFields()
                }
            },
            getEmptyObject() {
                return {
                    // Form data
                    title: "",
                    whenDate: "",
                    whenTime: "",
                    branchId: "",
                    isPrivate: false,
                    description: "",
                }
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        if (this.adding) {
                            this.$parent.objAdded(this.obj);
                        } else {
                            this.$parent.objEdited(this.obj);
                        }
                    } else {
                        this.openAlert('Gelieve alle informatie correct in te vullen.', 'error');
                        return false;
                    }
                });
            },
            close() {
                this.loading = false;
                this.dialogVisible = false;
            },
            openAlert(msg, type) {
                this.$message({
                    showClose: true,
                    message: msg,
                    type: type
                });
                return false;
            }
        }
    }

</script>


// WEBPACK FOOTER //
// src/components/dashboard/agenda/dialogs/EventDialog.vue